import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as CoinsSVG } from "../../../../../../../images/svg/public/order/coins.svg";

const CustomTipSectionHeader = () => {
	const { t } = useTranslation();
	return (
		<div className="d-flex flex-column align-items-center gap-3">
			<CoinsSVG />
			<h1>{t("modules.e_order.field.tip.title")}</h1>
		</div>
	);
};

export default CustomTipSectionHeader;
